import { render, staticRenderFns } from "./CurriculumStatus.vue?vue&type=template&id=a6a7fa84"
import script from "./CurriculumStatus.vue?vue&type=script&lang=js"
export * from "./CurriculumStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a7fa84')) {
      api.createRecord('a6a7fa84', component.options)
    } else {
      api.reload('a6a7fa84', component.options)
    }
    module.hot.accept("./CurriculumStatus.vue?vue&type=template&id=a6a7fa84", function () {
      api.rerender('a6a7fa84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/CurriculumStatus.vue"
export default component.exports